<template>
    <div class="w-full flex flex-col pt-1">
          <div class="flex flex-row "  :class="['input-field__input input-field-wrapper',{'input-field__input--focused': on_focus_theme},{'input-field__input--error': empty==true && required}]">
            <input type="text" placeholder="+63" v-show="text_type=='mobile'" disabled class="w-full max-w-xxs text-center input-field__static"/>
              <input v-if="id=='tin'"
                  :id="id" 
                  :type="'tel'" 
                  v-model="curr_val"
                  v-mask="'###-###-###'"
                  @paste="pasted"
                  @keypress="checkEmpty"
                  @keyup.enter="enter"
                  @focus="onFocus"
                  @blur="onBlur"
                  class="w-full max-w-full bg-transparent appearance-none leading-6 p-3 text-gray-700 text-base focus:outline-none"  
              />
              <input v-else
                  :id="id" 
                  @input="uppercase?this.curr_val = $event.target.value.toUpperCase():this.curr_val = $event.target.value"
                  :type="text_type=='mobile'?'number':text_type" 
                  v-model="curr_val"
                  :disabled="disable"
                  @keyup.backspace="backspace"
                  @keypress="speckeydown"
                  @keyup.enter="enter"
                  @focus="onFocus"
                  @blur="onBlur"
                  @paste="pasted"
                  class="w-full max-w-full bg-transparent appearance-none leading-6 p-3 text-gray-700 text-base focus:outline-none"  
              />
              <div
                  @click="clickPlaceholder"
                  :class="[
                      'input-field__placeholder',{'input-field-number__placeholder--focused':floatOn && text_type=='mobile','flex flex-row':required},
                      { 'input-field__placeholder--focused': floatOn },{'input-field-number__placeholder ':text_type == 'mobile'}
                  ]"
                  >
                  <div v-if="required" class=" flex text-red-600 pt-1 pr-1">
                    <span v-text="'*'"  class="self-center"/>
                  </div>
                  <span v-text="placeholder"/>
              </div>
              <div v-if="this.has_icon" class="px-2">
                  <div class="w-icon-24 h-icon-24 peek-margin">
                      <Icons id="textbox_icon" v-bind:source="getImgSrc()" @click="togglePeeker" :width="24" />
                  </div>
              </div>
          </div>
           <div class="text-red-600" v-if="error_message && (id =='email' || id=='mobile' || id=='tin')">
            {{error_message}}
          </div>
          
        <div v-if="strength && curr_val" class="mt-2">
          <PasswordStrength v-bind:value="curr_val" @score="passwordStrength" />
        </div>
    </div>
 
</template>
<script>
import { defineComponent } from 'vue';
import Icons from './Icon.vue';
import PasswordStrength from './PasswordStrength.vue';
import User from '@/services/User';
export default defineComponent({
    components:{
      Icons,
      PasswordStrength
    },
    props:{
            id: {
                type:String,
                required:true,
            },
            type: {
                type:String,
                required:false,
                default:'text'
            },
            placeholder: {
                type:String,
                required:false,
            },
            initial:{
                type:String,
                required:false
            },
            has_error: {
                type:Boolean,
                required:false,
            },
            peekable: {
                type: Boolean,
                required: false,
                default: false,
            },
            strength: {
                type: Boolean,
                required: false,
                default: false,
            },
            uppercase:{
              type:Boolean,
              required: false,
            },
            nonumbers:{
              type:Boolean,
              required:false,
            },
            nospecial:{
              type:Boolean,
              required:false,
            },
            max_length: {
              type:Number,
              required:false,
            },
            required:{
              type:Boolean,
              required: false,
            },
            nopaste:{
              type:Boolean,
              required:false,
            },
            disable:{
              type:Boolean,
              required:false,
            }
    },
    data(){
        return {
            curr_val:'',
            value:'',
            text_type:'text',
            isFocused:false,
            empty:false,
            has_icon: false,
            on_focus_theme:false,
            visible: false,
            icon:'',
            invalid_email:false,
            invalid_number:false,
            error_message:'',
        }
    },
    watch: {
        curr_val(value) {
          if(value){
            this.$emit("changed", {
                key: this.id,
                value: value,
            });
            this.value = value;
          }
        }
    },
    mounted(){
        if(this.type) {
            this.text_type = this.type;
        }
         if(this.type == "Password" && this.peekable)
          {
              this.has_icon = true;
          }
        this.curr_val = this.initial;
    },
    
    methods:{
        getImgSrc() {
            return !this.visible ? "images/papsi_invi_icon.svg" : "images/papsi_vis_icon.svg";
        },
        backspace(e){
          if(e.target.value.length == 0){
            this.$emit("changed", {
                key: this.id,
                value: '',
            });
            this.value = '';
          }
        },
        clickPlaceholder() {
            this.isFocused = true;
        },
        passwordStrength(n) {
            this.$emit('score', n);
        },
        onFocus() {
            this.isFocused= true;
            this.on_focus_theme = true;
        },
        enter() {
            this.$emit('enter');
        },
        onBlur() {
            this.isFocused= false;
            this.on_focus_theme = false;
        },
        getValue() {
            return this.value != null ? this.value : this.curr_value;
        },
        checkEmpty() {
          let that = this;
          if(!that.curr_val) {
            that.empty = true;
            this.$emit('hasError',this.id);
          } else {
            that.empty = false;
            this.$emit('clearError',this.id);
          }
        },
        pasted(e) {
          if(this.nopaste){
             this.$emit('pasted', e.clipboardData.getData('text'));
             e.preventDefault();
          }
        },
        togglePeeker() {
            if(this.visible)
            {
                this.text_type = "password";
                this.visible = false;
            }
            else
            {
                this.text_type = "text";
                this.visible = true;
            }
        },
        checkValidNumber() {
          if(/^(9)\d{9}$/.test(this.curr_val)) {
            this.empty = false;
            this.invalid_number = false;
          }else{
            this.empty = true;
            this.invalid_number = true;
          }
        },
        checkDuplicate() {
          let that = this;
          let payload;

          if(that.id == 'tin' && that.curr_val) {
              payload = {
              type:5,
              value:that.curr_val,
            }
          }
          if(that.id =='mobile' && that.curr_val) {
            payload = {
              type:3,
              value:'+63'+that.curr_val,
            }
          }
          if(that.id=='email' && that.curr_val) {
              payload = {
              type:2,
              value:this.curr_val,
            }
          }
          User.testData(payload).then(function(){
             that.error_message ='';
          }).catch(function(error){
             
            if(that.id=='mobile') {
              that.empty = true;
            }
            if(that.id=='email') {
              that.empty = true;
            }
            if(that.id=='tin') {
              that.empty = true;
            }
            that.error_message = error.response.data.message;
          });
        },
        validateEmail() {
          if (/^\w+([\\.-]?\w+)*@\w+([\\.-]\w+)*(\.\w{2,3})+$/.test(this.curr_val)) {
              this.invalid_email = false;
              this.empty = false;
          } else {
              this.empty = true;
              this.invalid_email = true;
          }
        },
        clearText() {
          this.curr_val = '';
        },
        speckeydown(e) {
            this.checkEmpty();
            if (/^[*|\\":<>[\]{}`\\()'?/!.#%;^=_@&+$0,-9]*$/.test(e.key) && this.nonumbers && this.nospecial) {
                e.preventDefault();
            }
            if(/^["`']*$/.test(e.key) && this.id == 'email' ) {
               e.preventDefault();
            }
            if(/^[*|\\":<>[\]{}`\\()'?/!.#%;^=_@&+$]*$/.test(e.key) && this.nospecial) {
                e.preventDefault();
            }
            if(/^0/.test(e.key) && this.text_type == 'mobile' && e.target.value.length<1) {
                e.preventDefault();
            }
            if(e.target.value.length >this.max_length) {
              e.preventDefault();
            }
        },        
    },
    computed: {
        floatOn() {
          if(this.curr_val){
            return this.isFocused || this.value.toString().length > 0;
          }else {
            return this.isFocused;
          }
          
        },
    },

});
</script>
<style scoped>
.input-field__input {
  width: 100%;
  height: 100%;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 16px;
  border: 2px solid #bcbcbc;
  border-radius: 5px;
  outline: none;
}
.input-field__static {
  width: 100%;
  /* margin-top: -10px; */
  font-family: Arial, Helvetica, sans-serif;
  font-size: 16px;
  border-right: 2px solid #bcbcbc;
  outline: none;
}
.input-field__input--error {
  border: 2px solid #f00f0f !important;
}
input[type=number]::-webkit-inner-spin-button, 
input[type=number]::-webkit-outer-spin-button { 
  -webkit-appearance: none; 
  margin: 0; 
}
.input-field-wrapper {
  padding-top: 3px;
  position: relative;
}
.input-field__input {
  width: 100%;
  height: 100%;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 18px;
  border: 2px solid #bcbcbc;
  border-radius: 5px;
  outline: none;
}
.input-field__input--focused {
  border: 2px solid #016b00;
}
.input-field__input--empty {
  border: 2px solid #db0404;
}
.input-field__placeholder {
  position: absolute;
  font-size: 18px;
  left: 12px;
  top: 19px;
  padding: 0 5px;
  background: transparent;
  transition: all 0.3s;
  line-height: 12px;
}
.input-field-number__placeholder {
  position: absolute;
  font-size: 18px;
  left: 85px;
  top: 19x;
  padding: 0 5px;
  background: transparent;
  transition: all 0.3s;
  line-height: 12px;
}
.input-field__placeholder--focused {
  top: 5px;
  font-size: 14px;
  left: 2px;
}
.input-field-number__placeholder--focused {
  top: 5px;
  font-size: 14px;
  left: 85px;
}
.peek-margin {
    margin-top: 11px;
}
</style>
